import ClientSelect from "app/modules/shared/selectComponents/clientSelect/ClientSelect";
import DevelopmentSelect from "app/modules/shared/selectComponents/developmentSelect/DevelopmentSelect";
import PurchaseAccountSelect from "app/modules/shared/selectComponents/purchaseAccountSelect/PurchaseAccountSelect";
import { MeetingAttendeeTypes } from "global/enums";
import { GuidSelectModel, MeetingModel, NewMeetingModel } from "services/api/cplapi/CPLAPI";
import translations from "utils/translationUtility";

export const ClearUnusedAttendees = (
  meetingAttendeeType: MeetingAttendeeTypes,
  values: NewMeetingModel | MeetingModel
) => {
  switch (meetingAttendeeType) {
    case MeetingAttendeeTypes.Development:
      values.clientID = undefined;
      values.purchaseAccountID = undefined;
      break;
    case MeetingAttendeeTypes.Client:
      values.developmentID = undefined;
      values.purchaseAccountID = undefined;
      break;
    case MeetingAttendeeTypes.Purchase:
      values.developmentID = undefined;
      values.clientID = undefined;
      break;
    default:
      values.developmentID = undefined;
      values.clientID = undefined;
      values.purchaseAccountID = undefined;
      break;
  }
};

export const GetAttendeeTypeName = (attendeeType: MeetingAttendeeTypes) => {
  switch (attendeeType) {
    case MeetingAttendeeTypes.Development:
      return "Development";
    case MeetingAttendeeTypes.Client:
      return translations.client;
    case MeetingAttendeeTypes.Purchase:
      return "Purchase Account";
    case MeetingAttendeeTypes.Other:
      return "Other";
    default:
      throw new Error("Invalid attendee type");
  }
};

export const GetMeetingSelect = (
  attendeeType: MeetingAttendeeTypes,
  values: MeetingModel | NewMeetingModel,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
) => {
  switch (attendeeType) {
    case MeetingAttendeeTypes.Development:
      return (
        <div className="row mb-6">
          <label className="col-lg-4 form-label">Development</label>
          <div className="col-lg-8">
            <DevelopmentSelect
              data-test-id="meeting-form__development-select"
              defaultSelectedValue={values.developmentID}
              handleChange={(selection: GuidSelectModel) => {
                setFieldValue("developmentID", selection.value);
              }}
              disabled={false}
              enableReinitialise
            />
          </div>
        </div>
      );
    case MeetingAttendeeTypes.Client:
      return (
        <div className="row mb-6">
          <label className="col-lg-4 form-label">{translations.client}</label>
          <div className="col-lg-8">
            <ClientSelect
              data-test-id="meeting-form__client-select"
              defaultSelectedValue={values.clientID}
              handleChange={(selection: GuidSelectModel) => {
                setFieldValue("clientID", selection.value);
              }}
              disabled={false}
              enableReinitialise
            />
          </div>
        </div>
      );
    case MeetingAttendeeTypes.Purchase:
      return (
        <div className="row mb-6">
          <label className="col-lg-4 form-label">Purchase Account</label>
          <div className="col-lg-8">
            <PurchaseAccountSelect
              data-test-id="meeting-form__purchase-account-select"
              defaultSelectedValue={values.purchaseAccountID}
              handleChange={(selection: GuidSelectModel) => {
                setFieldValue("purchaseAccountID", selection.value);
              }}
              disabled={false}
              enableReinitialise
            />
          </div>
        </div>
      );
    default:
      return <></>;
  }
};
